/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return function onSubmit() {
    props?.closePopover()
  }
}
